import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Page } from "@models/page";
import { Transaction, TransactionTypeEnum } from "@models/transaction";
import { PaginatorModule, PaginatorState } from "primeng/paginator";
import { SkeletonModule } from "primeng/skeleton";
import { TableModule } from "primeng/table";
import { TransactionTypeEnumPipe } from "../../../shared/pipes/transaction-type-enum.pipe";

@Component({
  selector: "app-account-statement-table",
  standalone: true,
  imports: [
    CommonModule,
    TableModule,
    PaginatorModule,
    SkeletonModule,
    TransactionTypeEnumPipe,
  ],
  templateUrl: "./account-statement-table.component.html",
  styleUrl: "./account-statement-table.component.scss",
})
export class AccountStatementTableComponent {
  first = 0;
  rows = 10;
  private _transactions: Page<Transaction> | null = null;

  @Input()
  set transactions(value: Page<Transaction> | null) {
    this._transactions = value;

    if (!value) return;

    this.rows = value.meta.page_size ?? this.rows;
    const currentPage = Math.max(value.meta.current_page, 1);
    this.first = (currentPage - 1) * this.rows;
  }

  get transactions(): Page<Transaction> | null {
    return this._transactions;
  }

  isDebit(transactionType: TransactionTypeEnum): boolean {
    return [
      TransactionTypeEnum.MULTA_CANCELAMENTO,
      TransactionTypeEnum.PDV_FEE,
      TransactionTypeEnum.PDV_FEE_DEBIT,
    ].includes(transactionType);
  }

  @Output() pageChange = new EventEmitter<PaginatorState>();

  signedAmount(transaction: Transaction): number {
    const amount = Number(transaction.amount);
    if (this.isDebit(transaction.transaction_type)) {
      return -Math.abs(amount);
    }
    return amount;
  }

  handlePageChange(event: PaginatorState): void {
    this.first = event.first ?? 0;
    this.rows = event.rows ?? this.rows;
    this.pageChange.emit({ ...event, first: this.first, rows: this.rows });
  }
}
